import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';
import { LocaleContext } from '../../Banner';
import Step from './../Step';
import { executeAction, open } from '../../utils';

const StepsWrapper = ({ bar }) => {
  const { dataJurisdiction } = useContext(LocaleContext);

  return (
    bar.steps?.length > 0 && (
      <div
        id="banners-tabs-wrapper"
        className={cn(styles.bannersTabsWrapper)}
        data-jurisdiction={dataJurisdiction}
        data-testid="banners-tabs-wrapper"
      >
        <div className={cn(styles.tabsGroup)}>
          {bar.steps.map((step, key) => {
            return (
              <Step
                step={step}
                key={`step-${JSON.stringify(step?.heading || step)}`}
                keyValue={key}
                stepClick={() =>
                  step?.select_action ? executeAction(step.select_action, step.headline.href) : open(bar.url)
                }
              />
            );
          })}
        </div>
      </div>
    )
  );
};

StepsWrapper.propTypes = {
  bar: PropTypes.shape({
    steps: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
    url: PropTypes.string,
  }).isRequired,
};

export default StepsWrapper;
